import React from 'react'

export type PageNavProps = {
  total : number;
  offset : number;
  limit: number
  other? : any
  prevPage: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  nextPage: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  // value?:'A'|'F'|'P'|'O'|'C'
}

/** `PageNav` */
function PageNav(props : PageNavProps){
  const { total, offset, limit, prevPage, nextPage } = props

  return (
    <div className='pagenav'>
      {/* <div className='text'>
        {total}개중 {offset/limit+1} -{Math.ceil(total/limit)}
        {total}개중 {(offset/limit)*limit+1} -{total<(offset/limit+1)*limit?total:(offset/limit+1)*10}
      </div> */}
      <button className={`btn medium ${offset/limit+1===1?'disabled':''}`} onClick={prevPage}>
        <span className={`prev`}></span>
      </button>
      <span className='text'>
        {/* {total}개중 {offset/limit+1} -{Math.ceil(total/limit)} */}
        {offset/limit+1}/ {Math.ceil(total/limit)}
      </span>
      <button className={`btn medium ${offset/limit+1===Math.ceil(total/limit)?'disabled':''}`} onClick={nextPage}>
      <span className={`next`}></span>
      </button>
    </div> 
  ) 
}

export default PageNav;